var _path, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgSwapFilters = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10623_5351",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.00037 2H21.5V21.5007H2.00037V2Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10623_5351)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.77337 11.5987C8.79137 11.6147 8.80837 11.6297 8.82537 11.6477C9.90437 12.7537 10.4994 14.2187 10.4994 15.7737V19.7577L12.7354 18.5397C12.9114 18.4437 13.0204 18.2557 13.0204 18.0487V15.7617C13.0204 14.2127 13.6094 12.7527 14.6784 11.6527L19.5154 6.50769C19.8284 6.17469 20.0004 5.73769 20.0004 5.27669V4.34069C20.0004 3.87669 19.6344 3.49969 19.1864 3.49969H4.31537C3.86637 3.49969 3.50037 3.87669 3.50037 4.34069V5.27669C3.50037 5.73769 3.67237 6.1747 3.98537 6.50669L8.77337 11.5987ZM10.1464 21.5007C9.94437 21.5007 9.74437 21.4467 9.56237 21.3387C9.21037 21.1287 8.99937 20.7577 8.99937 20.3457V15.7737C8.99937 14.6387 8.57637 13.5697 7.80537 12.7507C7.78237 12.7317 7.75937 12.7107 7.73937 12.6887L2.89337 7.53569C2.31737 6.92369 2.00037 6.12069 2.00037 5.27669V4.34069C2.00037 3.04969 3.03937 1.99969 4.31537 1.99969H19.1864C20.4614 1.99969 21.5004 3.04969 21.5004 4.34069V5.27669C21.5004 6.11969 21.1834 6.92169 20.6094 7.53469L15.7624 12.6887C14.9594 13.5167 14.5204 14.6057 14.5204 15.7617V18.0487C14.5204 18.8047 14.1114 19.4967 13.4534 19.8567L10.6924 21.3607C10.5204 21.4537 10.3334 21.5007 10.1464 21.5007Z",
    fill: "#CD081E"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSwapFilters, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/swap-filters.54cb6672.svg";
export { ForwardRef as ReactComponent };